import { useQuery, useMutation, UseQueryOptions, UseQueryResult } from 'react-query'
import { QueryKeys } from './_query_keys'
import { useState } from 'react'
import { APIEndpoints } from '../constants/api-endpoints'
import { HttpRequest } from '../services/_http'

export const useGetShows = (searchOptions?: any, options?: UseQueryOptions): UseQueryResult<any> => {
    const method = 'GET'
    const queryKey = [QueryKeys.SHOW, searchOptions]
    /** To keeping old data until response received with new data */
    const [keepPreviousData, setkeepPreviousData] = useState(true)
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: APIEndpoints.Show,
            params: searchOptions,
            method
        }),
        refetchOnWindowFocus: false,
        keepPreviousData,
        onError: () => setkeepPreviousData(false),
        onSuccess: () => setkeepPreviousData(true),
        ...options
    })
}

export const useAddShow = (options?: any) => {
    const method = 'POST'

    return useMutation(({ data }: { data: any }) => HttpRequest({
        url: `${APIEndpoints.Show}`,
        method,
        data
    }), options)
}

export const useUpdateShow = (options?: any) => {
    const method = 'PUT'
    return useMutation(({ data, id }: { data: FormData, id: any }) => HttpRequest({
        url: `${APIEndpoints.Show}/${id}`,
        method,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        data
    }), options)
}

export const useDeleteShow = (options?: any) => {
    const method = 'DELETE'
    return useMutation(({ id }: { id: any }) => HttpRequest({
        url: `${APIEndpoints.Show}/${id}`,
        method,
    }), options)
}

export const useUpdateShowStatus = (options?: any) => {
    const method = 'PATCH'
    return useMutation(({ data, id }: { data: any, id: any }) => HttpRequest({
        url: `${APIEndpoints.Show}/${id}/status`,
        method,
        data
    }), options)
}


export const useShowContent = (id: any, options?: UseQueryOptions): UseQueryResult<any> => {

    const method = 'GET'
    const queryKey = [QueryKeys.SHOW_CONTENT, id]
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.Show}/${id}/content`,
            method
        }),
        enabled: !!id,
        refetchOnWindowFocus: false,
        ...options
    })
}

export const useShowSearch = (searchTerm = '') => {
    return useQuery(
        ['show-search', searchTerm],
        async () => {
            if (!searchTerm.trim()) {
                return [];
            }

            const { data } = await HttpRequest({
                url: `/shows/search/all?search=${encodeURIComponent(searchTerm)}`,
                method: 'GET'
            });
            return data;
        },
    );
};

export const fetchShowSearchApi = async (search: string) => {
    const { data } = await HttpRequest({
        url: `/shows/search/all?search=${encodeURIComponent(search)}`,
        method: 'GET'
    });
    return data?.results;
};

export const fetchShowEpisodeSearchApi = async (search: string) => {
    const { data } = await HttpRequest({
        url: `/shows/search/show-episode?search=${encodeURIComponent(search)}`,
        method: 'GET'
    });
    return data?.results;
};

export const fetchShowEpisodeSearchParentApi = async (search: string) => {
    const { data } = await HttpRequest({
        url: `/shows/search/show-episode-with-parent?search=${encodeURIComponent(search)}`,
        method: 'GET'
    });
    return data?.results;
};

export const useShowEpisodeSearch = (searchTerm = '') => {
    return useQuery(
        ['show-episode-search', searchTerm],
        async () => {
            if (!searchTerm.trim()) {
                return [];
            }

            const { data } = await HttpRequest({
                url: `/shows/search/show-episode?search=${encodeURIComponent(searchTerm)}`,
                method: 'GET'
            });
            return data;
        },
    );
};

export const useShowsSearch = (searchTerm: string) => {
  return useQuery({
    queryKey: ["show-search", searchTerm],
    enabled: Boolean(searchTerm.trim()),
    keepPreviousData: true,
    staleTime: 30 * 1000, // 30 seconds
    queryFn: async () => {
      const { data } = await HttpRequest({
        url: `/shows/search/all?search=${encodeURIComponent(searchTerm)}`,
        method: "GET"
      })
      return data
    }
  })
}